import LogoLoader from "src/components/views/loading/logoLoader"
import Loading from "src/components/views/loading"
import useConfig from "src/hooks/useConfig"

function LoaderConditional() {
  const { learnmachineAuthPage } = useConfig()

  if (learnmachineAuthPage === true) return <LogoLoader />
  return <Loading />
}

export default LoaderConditional
